export { InputNumber, InputNumberProps } from 'antd'
